import { collectionPath, defineModelSpec, orderBy } from '@elara/firebolt/shared';

import { ShortlistItemBaseSchema } from './schemas/shortlist-schemas.js';
import { id, tripId } from './schemas/zod-types.js';

/**
 * The canonical `ModelSpec` for the shortlist subcollection within a trip.
 * It defines the path (`trips/{tripId}/shortlist/{id}`) and the data shape for a shortlist item document.
 * Shortlist items represent saved recommendations that users want to consider for their trip.
 */
export const ShortlistItemModelSpec = defineModelSpec({
  path: collectionPath`trips/${tripId}/shortlist/${id}`,
  shape: ShortlistItemBaseSchema.shape,
  constraints: [orderBy('position', 'asc')],
});

export type ShortlistItemModelSpec = typeof ShortlistItemModelSpec;
export type ShortlistItemData = ShortlistItemModelSpec['DataType'];

